<!--商品新增-->
<template>
  <div class="edit-area">
    <el-form ref="registerRef"  :model="detailParam" :rules="rules" label-width="140px">
      <el-form-item  label="商品名称:" prop="goodsName" >
        <el-input style="width: 300px" v-model="detailParam.goodsName" placeholder=""></el-input>
      </el-form-item>
      <el-form-item  label="商品编号:"  prop="goodsId">
        <el-input style="width: 300px" v-model="detailParam.goodsId" placeholder=""></el-input>
      </el-form-item>
      <el-form-item  label="商品分类:" prop="goodsType" >
        <el-input style="width: 300px" v-model="detailParam.goodsType"></el-input>
      </el-form-item>
      <el-form-item  label="商品单位:" prop="unit" >
        <el-input style="width: 300px" v-model="detailParam.unit"></el-input>
      </el-form-item>

      <el-form-item  label="品牌:" prop="floor" >
        <el-input style="width: 300px" v-model="detailParam.floor"></el-input>
      </el-form-item>
      <el-form-item  label="价格:" prop="price" >
        <el-input style="width: 300px" v-model="detailParam.price"></el-input>
      </el-form-item>
      <el-form-item  label="成本:" prop="cost" >
        <el-input style="width: 300px" v-model="detailParam.cost"></el-input>
      </el-form-item>
      <el-form-item  label="备注:" >
        <el-input
          type="textarea"
          placeholder=""
          v-model="detailParam.remark"
          maxlength="30"
          show-word-limit
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer-1" >
      <el-button  @click="handleCancel()">取消</el-button>
      <el-button type="primary" @click="handleOK('registerRef')">确认</el-button>
    </div>
  </div>
</template>
<style>

</style>

<script>
  import globaldata from "../../../../utils/globaldata";
  export default {
    name: 'goodsDetail',
    props: {
      title: {
        msg: ''
      },
      detailParam :{
        id:'',
        shopFrontId:'',
        goodsId:'',
        goodsName :''  ,
        goodsType : '' ,
        unit : '' ,
        brand : '' ,
        price : 0,
        cost : 0 ,
        status : '0' ,
        remark:'',
      },
    },
    data() {
      return {
        rules:{
          goodsId:[{required:true,message:"请输入商品编号",trigger:"blur"}],
          goodsName:[{required:true,message:"请输入商品名称",trigger:"blur"}],
        },
      }
    },
    created(){
    },
    mounted() {

    },
    methods: {
      handleOK(registerRef){
        this.$refs[registerRef].validate((valid) => {
          if (valid) {
            this.onGoods();
          } else {
            return false
          }
        });
      },
      handleCancel(){
        this.$emit('onBtnCancel');
      },
      //新增商品
      onGoods(){
        this.$emit('onGoods',this.detailParam);

      },
      doUpdatePosition(t,dlg){

      },
    }
  }
</script>






// WEBPACK FOOTER //
// src/views/my-store/goods/components/goodsDetail.vue